import { render } from "./IssueCard.vue?vue&type=template&id=47d98f5b"
import script from "./IssueCard.vue?vue&type=script&lang=js"
export * from "./IssueCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__